export default __webpack_public_path__ + "static/media/cards.b7c2bdbd.svg";